// extracted by mini-css-extract-plugin
export var container = "PrimaryTopNav-module--container--661b3";
export var current = "PrimaryTopNav-module--current--6903a";
export var currentLink = "PrimaryTopNav-module--currentLink--c3906";
export var dropdown = "PrimaryTopNav-module--dropdown--a48cb";
export var dropdownCurrent = "PrimaryTopNav-module--dropdownCurrent--5f4db";
export var dropdownCurrentLink = "PrimaryTopNav-module--dropdownCurrentLink--6b269";
export var dropdownOverflow = "PrimaryTopNav-module--dropdownOverflow--d4280";
export var isOpen = "PrimaryTopNav-module--isOpen--d1ca6";
export var label = "PrimaryTopNav-module--label--d8f98";
export var li = "PrimaryTopNav-module--li--83e78";
export var link = "PrimaryTopNav-module--link--97fa8";
export var menuToggle = "PrimaryTopNav-module--menuToggle--d7cd5";
export var menuToggleContainer = "PrimaryTopNav-module--menuToggleContainer--6d40c";
export var mobileLink = "PrimaryTopNav-module--mobileLink--d75de";
export var primary = "PrimaryTopNav-module--primary--30393";
export var toggleIcon = "PrimaryTopNav-module--toggleIcon--1e4ee";
export var ul = "PrimaryTopNav-module--ul--85d4b";